import React, {useState} from 'react';
import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import {getLanguage, t} from 'react-switch-lang';
import Trash from './img/delete.svg';
import './Modals.css';
import returnTitle from './ModalData/Title';
import modalBody from './ModalData/ModalBody';
import Exclusion from './img/Exclusion 2.svg';

export function Delete(props) {
  const [modal, setModal] = useState(false);
  const userModal = () => setModal(!modal);

  const body = () => {
    const MyComponent = modalBody(props.id).delete;
    if (MyComponent !== null) {
      return (
        <MyComponent
          data={props.data}
          toggleModal={() => setModal(false)}
          setRowChanged={() => props.setRowChanged()}
        />
      );
    } else {
      return '';
    }
  };

    return (
        <>
            <Button className="danger modal-open-button" onClick={userModal}>
                {props.noImage ?
                    ''
                    :
                    <img src={Trash} alt="icon"
                         style={{width: '14px', height: '14px'}}/>
                }
                <span>
          {props.customText ?
              props.customText
              :
              t('buttons.deleteBtn')
          }
        </span>
            </Button>
            <Modal
                isOpen={modal}
                toggle={userModal}
                className="modal-md modalDelete"
                backdrop="static"
            >
                <ModalHeader toggle={userModal}>
                    <div>
                        {t('buttons.deleteBtn')} {returnTitle(props.id).toLowerCase()}{' '}
                    </div>
                    <img
                        src={Exclusion}
                        alt="Exclusion"
                        onClick={userModal}
                        style={{cursor: 'pointer'}}
                    />
                </ModalHeader>
                <ModalBody className="d-flex flex-row">
                    <div>
                        <div className="row">
                            <div className="py-2 my-2">
                                <h3>
                                    {' '}
                                    {`${t('question.delete', {entity: getLanguage() === "eng" ? props?.data?.nameEn : props?.data?.name})}`}
                                </h3>
                            </div>
                            <div
                                className="container-fluid decorationLine"></div>
                            <div className="text-righ offset-5">
                                <Button onClick={userModal}
                                        className="danger cancelButton">
                                    {t('buttons.cancelBtn')}
                                </Button>
                            </div>
                            <div className="text-right">{body()}</div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
}
